import { createListenerMiddleware } from '@reduxjs/toolkit';
import { closeModal, confirmModal } from 'features/modal/modalSlice';
import { onSuccess } from 'features/toast/toast.slice';
import { removeConfig } from './platform-config/platform-config.slice';

export const accountIdDeleteOnModelConfirmMiddleware =
  createListenerMiddleware();

accountIdDeleteOnModelConfirmMiddleware.startListening({
  actionCreator: confirmModal,
  effect: async (action, listenerApi) => {
    const {
      payload: { title, additionalProps }
    } = action;
    if (title === 'Remove Account ID' && additionalProps) {
      listenerApi.dispatch(
        removeConfig({
          platformType: additionalProps.platformType,
          accountId: additionalProps.accountId
        })
      );

      listenerApi.dispatch(closeModal());
      listenerApi.dispatch(
        onSuccess({
          title: 'Account Removed',
          description: 'Please Re-Validate this setup.'
        })
      );
    }
  }
});
